import React from "react";
import "./Footer.css";
import logo from "../../assets/images/logo.png";
import { NavLink } from "react-router-dom";
import { BRAND } from "../../data/brand";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-columns">
          <div className="footer-column">
            <img src={logo} alt={BRAND.name} className="footer-logo" />
          </div>
          <div className="footer-column">
            <p>
              {BRAND.description} Trusted by thousands of Indian students since{" "}
              {BRAND.foundedYear}.
            </p>
          </div>
          <div className="footer-column">
            <h3>Contact</h3>
            <p>Email: {BRAND.email}</p>
            <p>Phone: {BRAND.phone}</p>
            <p>Address: {BRAND.address}</p>
          </div>
          <div className="footer-column">
            <h3>Navigation</h3>
            <ul>
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/about">About</NavLink></li>
              <li><NavLink to="/services">Services</NavLink></li>
              <li><NavLink to="/pricing">Pricing</NavLink></li>
              <li><NavLink to="/resources">Resources</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom text-center">
          <p>
            &copy; {new Date().getFullYear()} {BRAND.name}. All Rights Reserved.{" "}
            <NavLink to="/terms">Terms</NavLink> | <NavLink to="/privacy">Privacy</NavLink>
          </p>
          <div className="footer-icons">
            <a href={BRAND.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
              <i className="fa fa-facebook"></i>
            </a>
            <a href={BRAND.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
              <i className="fa fa-instagram"></i>
            </a>
            <a href={BRAND.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <i className="fa fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
